export default __webpack_public_path__ + "static/media/icon.988e1c14.png";